/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './instance.reducer';

export const Instance = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const instanceList = useAppSelector(state => state.instance.entities);
  const loading = useAppSelector(state => state.instance.loading);
  const totalItems = useAppSelector(state => state.instance.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="instance-heading" data-cy="InstanceHeading">
        <Translate contentKey="tinyMedicRestApp.instance.home.title">Instances</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.instance.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/instance/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.instance.home.createLabel">Create new Instance</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.instance.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {instanceList && instanceList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.instance.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('sopInstanceUid')}>
                  <Translate contentKey="tinyMedicRestApp.instance.sopInstanceUid">Sop Instance Uid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sopInstanceUid')} />
                </th>
                <th className="hand" onClick={sort('instanceNumber')}>
                  <Translate contentKey="tinyMedicRestApp.instance.instanceNumber">Instance Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('instanceNumber')} />
                </th>
                <th className="hand" onClick={sort('sopClassUid')}>
                  <Translate contentKey="tinyMedicRestApp.instance.sopClassUid">Sop Class Uid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sopClassUid')} />
                </th>
                <th className="hand" onClick={sort('patientOrientation')}>
                  <Translate contentKey="tinyMedicRestApp.instance.patientOrientation">Patient Orientation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('patientOrientation')} />
                </th>
                <th className="hand" onClick={sort('mediaStorageSopInstanceUid')}>
                  <Translate contentKey="tinyMedicRestApp.instance.mediaStorageSopInstanceUid">Media Storage Sop Instance Uid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mediaStorageSopInstanceUid')} />
                </th>
                <th className="hand" onClick={sort('transferSyntaxUid')}>
                  <Translate contentKey="tinyMedicRestApp.instance.transferSyntaxUid">Transfer Syntax Uid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('transferSyntaxUid')} />
                </th>
                <th className="hand" onClick={sort('acquisitionDateTime')}>
                  <Translate contentKey="tinyMedicRestApp.instance.acquisitionDateTime">Acquisition Date Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('acquisitionDateTime')} />
                </th>
                <th className="hand" onClick={sort('imageType')}>
                  <Translate contentKey="tinyMedicRestApp.instance.imageType">Image Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('imageType')} />
                </th>
                <th className="hand" onClick={sort('pixelSpacing')}>
                  <Translate contentKey="tinyMedicRestApp.instance.pixelSpacing">Pixel Spacing</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pixelSpacing')} />
                </th>
                <th className="hand" onClick={sort('imageOrientation')}>
                  <Translate contentKey="tinyMedicRestApp.instance.imageOrientation">Image Orientation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('imageOrientation')} />
                </th>
                <th className="hand" onClick={sort('imagePosition')}>
                  <Translate contentKey="tinyMedicRestApp.instance.imagePosition">Image Position</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('imagePosition')} />
                </th>
                <th className="hand" onClick={sort('sliceThickness')}>
                  <Translate contentKey="tinyMedicRestApp.instance.sliceThickness">Slice Thickness</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sliceThickness')} />
                </th>
                <th className="hand" onClick={sort('sliceLocation')}>
                  <Translate contentKey="tinyMedicRestApp.instance.sliceLocation">Slice Location</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sliceLocation')} />
                </th>
                <th className="hand" onClick={sort('windowCenter')}>
                  <Translate contentKey="tinyMedicRestApp.instance.windowCenter">Window Center</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('windowCenter')} />
                </th>
                <th className="hand" onClick={sort('windowWidth')}>
                  <Translate contentKey="tinyMedicRestApp.instance.windowWidth">Window Width</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('windowWidth')} />
                </th>
                <th className="hand" onClick={sort('xrayTubeCurrent')}>
                  <Translate contentKey="tinyMedicRestApp.instance.xrayTubeCurrent">Xray Tube Current</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('xrayTubeCurrent')} />
                </th>
                <th className="hand" onClick={sort('exposureTime')}>
                  <Translate contentKey="tinyMedicRestApp.instance.exposureTime">Exposure Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('exposureTime')} />
                </th>
                <th className="hand" onClick={sort('kvp')}>
                  <Translate contentKey="tinyMedicRestApp.instance.kvp">Kvp</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('kvp')} />
                </th>
                <th className="hand" onClick={sort('contentDateTime')}>
                  <Translate contentKey="tinyMedicRestApp.instance.contentDateTime">Content Date Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('contentDateTime')} />
                </th>
                <th className="hand" onClick={sort('columns')}>
                  <Translate contentKey="tinyMedicRestApp.instance.columns">Columns</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('columns')} />
                </th>
                <th className="hand" onClick={sort('rows')}>
                  <Translate contentKey="tinyMedicRestApp.instance.rows">Rows</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rows')} />
                </th>
                <th className="hand" onClick={sort('photometricInterpretation')}>
                  <Translate contentKey="tinyMedicRestApp.instance.photometricInterpretation">Photometric Interpretation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('photometricInterpretation')} />
                </th>
                <th className="hand" onClick={sort('bitsAllocated')}>
                  <Translate contentKey="tinyMedicRestApp.instance.bitsAllocated">Bits Allocated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bitsAllocated')} />
                </th>
                <th className="hand" onClick={sort('bitsStored')}>
                  <Translate contentKey="tinyMedicRestApp.instance.bitsStored">Bits Stored</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bitsStored')} />
                </th>
                <th className="hand" onClick={sort('pixelRepresentation')}>
                  <Translate contentKey="tinyMedicRestApp.instance.pixelRepresentation">Pixel Representation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pixelRepresentation')} />
                </th>
                <th className="hand" onClick={sort('highBit')}>
                  <Translate contentKey="tinyMedicRestApp.instance.highBit">High Bit</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('highBit')} />
                </th>
                <th className="hand" onClick={sort('imageOrientationPatient')}>
                  <Translate contentKey="tinyMedicRestApp.instance.imageOrientationPatient">Image Orientation Patient</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('imageOrientationPatient')} />
                </th>
                <th className="hand" onClick={sort('imagePositionPatient')}>
                  <Translate contentKey="tinyMedicRestApp.instance.imagePositionPatient">Image Position Patient</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('imagePositionPatient')} />
                </th>
                <th className="hand" onClick={sort('frameOfReferenceUid')}>
                  <Translate contentKey="tinyMedicRestApp.instance.frameOfReferenceUid">Frame Of Reference Uid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('frameOfReferenceUid')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.instance.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.instance.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.instance.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.instance.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.instance.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('imageObservation')}>
                  <Translate contentKey="tinyMedicRestApp.instance.imageObservation">Image Observation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('imageObservation')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.instance.series">Series</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {instanceList.map((instance, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/instance/${instance.id}`} color="link" size="sm">
                      {instance.id}
                    </Button>
                  </td>
                  <td>{instance.sopInstanceUid}</td>
                  <td>{instance.instanceNumber}</td>
                  <td>{instance.sopClassUid}</td>
                  <td>{instance.patientOrientation}</td>
                  <td>{instance.mediaStorageSopInstanceUid}</td>
                  <td>{instance.transferSyntaxUid}</td>
                  <td>
                    {instance.acquisitionDateTime ? (
                      <TextFormat type="date" value={instance.acquisitionDateTime} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{instance.imageType}</td>
                  <td>{instance.pixelSpacing}</td>
                  <td>{instance.imageOrientation}</td>
                  <td>{instance.imagePosition}</td>
                  <td>{instance.sliceThickness}</td>
                  <td>{instance.sliceLocation}</td>
                  <td>{instance.windowCenter}</td>
                  <td>{instance.windowWidth}</td>
                  <td>{instance.xrayTubeCurrent}</td>
                  <td>{instance.exposureTime}</td>
                  <td>{instance.kvp}</td>
                  <td>
                    {instance.contentDateTime ? <TextFormat type="date" value={instance.contentDateTime} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>{instance.columns}</td>
                  <td>{instance.rows}</td>
                  <td>{instance.photometricInterpretation}</td>
                  <td>{instance.bitsAllocated}</td>
                  <td>{instance.bitsStored}</td>
                  <td>{instance.pixelRepresentation}</td>
                  <td>{instance.highBit}</td>
                  <td>{instance.imageOrientationPatient}</td>
                  <td>{instance.imagePositionPatient}</td>
                  <td>{instance.frameOfReferenceUid}</td>
                  <td>{instance.microSec}</td>
                  <td>{instance.timestampentry}</td>
                  <td>{instance.lastupdated}</td>
                  <td>{instance.cursor}</td>
                  <td>{instance.active ? 'true' : 'false'}</td>
                  <td>{instance.imageObservation}</td>
                  <td>{instance.series ? <Link to={`/series/${instance.series.id}`}>{instance.series.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/instance/${instance.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/instance/${instance.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/instance/${instance.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.instance.home.notFound">No Instances found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={instanceList && instanceList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Instance;
